// extracted by mini-css-extract-plugin
export default {"form":"BombBombSendForm_form__-TLN4"};